import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, message, Space} from "antd";
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";
import {CustomInputComponent} from "../../../../components/input/input-component";
import {AuthFormWrapper} from "../../../../layouts/auth-form-wrapper";
import {useCustomerLogin} from "../../../../react-query-hooks/auth";
import {customerLoginSchema} from "../login-form-validation-schema";
import {StyledAuthTitleCenterAlign} from "../../../../layouts/auth-form-wrapper/auth-form-wrapper.style";

const CustomerLoginPage = () => {
  const customerLoginQueryMutation = useCustomerLogin();
  const {
    handleSubmit,
    formState: {errors},
    watch,
    control,
  } = useForm<{emailAddress: string}>({
    resolver: yupResolver(customerLoginSchema),
    mode: "onChange",
  });

  const onSubmit = async (values: {emailAddress: string}) => {
    // console.log("cutomer login", values);
    customerLoginQueryMutation.mutate(
      {emailAddress: values.emailAddress.toLowerCase()},
      {
        onSuccess: () =>
          message.success("A confirmation link has been sent to your email address!"),
      }
    );
  };

  return (
    <AuthFormWrapper>
      <StyledAuthTitleCenterAlign>
        <div>
          <h2 className="form-main-heading">Log in as a customer</h2>
        </div>
      </StyledAuthTitleCenterAlign>
      <p className="login-option">Access and manage your purchases</p>
      {customerLoginQueryMutation.isSuccess && (
        <Alert
          message="Success"
          description="A confirmation link has been sent to your email address!"
          type="success"
          showIcon
        />
      )}
      <div
        style={{
          backgroundColor: "#EAE6F3",
          border: "1px solid #2E2640",
          borderRadius: "4px",
          padding: "1.6rem",
        }}
      >
        <ul>
          <li>
            Please log in here if you've purchased a product or booked a 1:1 session or
            live event.
          </li>
          <li style={{marginTop: "2.4rem"}}>
            Enter the same email address you used for your purchase or booking.
          </li>
          <li style={{marginTop: "2.4rem"}}>
            You can find all your purchases or bookings here.
          </li>
        </ul>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Space direction="vertical" size={29} style={{display: "flex"}}>
          <CustomInputComponent
            id="email"
            name="emailAddress"
            label="Email address"
            type="email"
            placeholder="Please enter your email address"
            error={errors.emailAddress?.message}
            control={control}
          />
          <div>
            <Button
              disabled={
                Object.keys(errors).length > 0 || Object.values(watch()).length < 1
              }
              block
              loading={customerLoginQueryMutation.isLoading}
              size="small"
              type="primary"
              htmlType="submit"
            >
              Log in
            </Button>
          </div>
          <p className="login-option">
            Are you a Coach?{" "}
            <Link style={{textDecoration: "underline", fontWeight: 600}} to="/auth/login">
              Log in to your account
            </Link>
          </p>
        </Space>
      </form>
    </AuthFormWrapper>
  );
};

export default CustomerLoginPage;
